import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { isAbsoluteUrl, isSeoOwnedPath, resolveNavigationHref } from '../../utils/routeOwnership';

const AppLink = forwardRef(function AppLink(
  {
    children,
    to,
    href,
    reloadDocument = false,
    onClick,
    target,
    rel,
    ...props
  },
  ref,
) {
  const destination = to ?? href ?? '';
  const resolvedHref = resolveNavigationHref(destination);
  const shouldHardNavigate =
    reloadDocument || isAbsoluteUrl(resolvedHref) || isSeoOwnedPath(destination);

  if (shouldHardNavigate) {
    return (
      <a
        ref={ref}
        href={resolvedHref}
        onClick={onClick}
        target={target}
        rel={rel}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      ref={ref}
      to={typeof destination === 'string' ? destination : destination || resolvedHref}
      onClick={onClick}
      target={target}
      rel={rel}
      {...props}
    >
      {children}
    </Link>
  );
});

export default AppLink;
